import {Injectable} from '@angular/core';
import {Auth0} from "./interface/auth0";
import {AuthService, IdToken, User} from "@auth0/auth0-angular";
import {Observable, Subscription} from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class Auth0Service implements Auth0 {

	public userSubscription: Subscription | null = null;
	public tokenSubscription: Subscription | null = null;

	constructor(
		private _auth0: AuthService,
	) {
	}

	public init(callback: (user: User | null | undefined) => void): void {
		this.userSubscription = this._auth0.user$.subscribe((user: User | null | undefined): void => callback(user));
	}

	public facebookLoginPopup(): Observable<void> {
		return this._auth0.loginWithPopup({
			authorizationParams: {
				connection: 'facebook',
				prompt: 'select_account'
			}
		});
	}

	public googleLoginPopup(): Observable<void> {
		return this._auth0.loginWithPopup({
			authorizationParams: {
				connection: 'google-oauth2',
				prompt: 'select_account'
			}
		});
	}

	public onError(callback: (error: Error) => void): void {
		this._auth0.error$.subscribe((error: Error) => {
			callback(error);
		})
	}

	public getIdToken(callback: (token: IdToken | null | undefined) => void): void {
		this.tokenSubscription = this._auth0.idTokenClaims$.subscribe((token): void => callback(token));
	}

	public destroyAll(): void {
		if (this.userSubscription !== null) {
			this.userSubscription.unsubscribe();
		}
		if (this.tokenSubscription !== null) {
			this.tokenSubscription.unsubscribe();
		}
		this._auth0.ngOnDestroy();
	}
}
